import React from "react";
import AppSidebarView from "./view";

export default function AppSidebar() {
  return <AppSidebarView />;
}
